import React from "react"
import Modal from "react-modal"
import TourStep from "./TourStep"
import Icon from "../elements/Icon"
import sharedMessages from "../../messages/index"
import { injectIntl } from "react-intl"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

class OnboardingModal extends React.Component {

  _next = () => {
    let currentStep = this.props.currentStep
    currentStep = currentStep === this.props.resources.length ? 1 : currentStep + 1
    this.props.updateCurrentStep(currentStep)
  }

  _previous = () => {
    let currentStep = this.props.currentStep
    currentStep = currentStep === 1 ? this.props.resources.length : currentStep - 1
    this.props.updateCurrentStep(currentStep)
  }

  render() {
    const {intl, showModal, resources, currentStep} = this.props
    const showNavButtons = resources.length > 1
    return(
      <Modal
          isOpen={showModal}
          ariaHideApp={false}
          onRequestClose={this.handleCloseModal}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5) !important"
            },
            content: {
              width: "370px",
              top: "88px !important",
              left: "calc((100% - 370px) / 2) !important",
              overflow: "initial !important",
              boxShadow: "none",
              transform: "unset"
            }
          }}
        >
          {getStyleTag('modal')}
          <span>
            <div className="modal-inner modal-inner--onboarding"
                 style={getStyles('modal-inner')}>
              {resources.map((edge, index) => (
                <TourStep
                  key={edge.id}
                  item={edge}
                  currentStep={currentStep}
                  index={index + 1}
                />
              ))}
              <hr/>
              { showNavButtons ?
                <div className="modal-navigation">
                  <button
                    className="button block"
                    onClick={this._previous}
                  >
                    {intl.formatMessage(sharedMessages.previous)}
                  </button>
                  <p>{currentStep}/{resources.length}</p>
                  <button
                    className="button pull-right block"
                    onClick={this._next}
                  >
                    {intl.formatMessage(sharedMessages.next)}
                  </button>
              </div>
              : null }
            </div>

            {getStyleTag('modal-close')}
            <button className="modal-close modal-close--onboarding" 
                    style={getStyles('modal-close')}
                    onClick={this.props.closeModal}>
              <Icon title="Close modal" icon="cross" />
            </button>
          </span>
        </Modal>
    )
  }
}

export default injectIntl(OnboardingModal);



// WEBPACK FOOTER //
// ./webapp/components/modules/OnboardingModal.js